// extracted by mini-css-extract-plugin
export default {"PicModalFooter":"PicModalFooter_PicModalFooter__TYqv+","deleteBtn":"PicModalFooter_deleteBtn__-Y0+e","collectBtn":"PicModalFooter_collectBtn__Oa2Hb"};